// hooks/useActivityLogger.js
import { useCallback } from 'react';
import useAuth from './useAuth';
import { db } from '../firebaseConfig';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';

export const useActivityLogger = () => {
    const { user } = useAuth();

    const logActivity = useCallback(async (type, target, details = '') => {
        if (!user) return;

        try {
            await addDoc(collection(db, 'user-activities'), {
                type: type,
                userId: user.uid,
                userName: user.nome || user.displayName || 'Usuário',
                userEmail: user.email,
                target: target,
                details: details,
                timestamp: serverTimestamp()
            });
        } catch (error) {
            console.error('Error logging activity:', error);
        }
    }, [user]);

    return { logActivity };
};